export const menuSections = [
    {
        title: 'INVOZIO',
        links: [
            { key: 'ABOUT_INVOZIO', en: 'about-invozio', sv: 'om-invozio' },
            { key: 'CONTACT_US', en: 'contact-us', sv: 'kontakta-oss' },
            { key: 'HOW_IT_WORKS', en: 'how-works-invozio', sv: 'hur-fungerar-invozio' },
            { key: 'FEATURES', en: 'function', sv: 'funktion' },
            { key: 'FAQ', en: 'faq', sv: 'faq' },
            // { key: 'NEWS', en: 'news', sv: 'nyheter' }, 
            { key: 'BECOME_AN_AMBASSADOR', en: 'ambassador', sv: 'ambassador' }
        ]
    },
    {
        title: 'FREELANCE_SERVICE',
        Nolinks: true,
        links: []
    },
    {
        title: 'FREELANCE_INVOICING',
        links: [
            { key: 'BOOKKEEPING', en: 'book-keeping', sv: 'bokforing' },  
            { key: 'FREELANCING_GUIDE', en: 'freelance-freelancing', sv: 'frilans-frilansarbete' },
            { key: 'SELF_EMPLOYED_INVOICING', en: 'invoicing-as-an-individual_self-employed', sv: 'fakturera-som-privatperson_egenanstalld' },
            { key: 'BUSINESS_OR_INVOICE_WITHOUT_COMPANY', en: 'invoice-without-company-or-business', sv: 'fakturera-utan-foretag-eller-bolag' },
            { key: 'FREELANCE_INCOME_POTENTIAL', en: 'how-much-should-I-invoice-as-a-freelancer', sv: 'hur-mycket-ska-jag-fakturera-som-frilansare' },
            { key: 'HEALTH_INSURANCE', en: 'health-insurance-main', sv: 'sjukforsakring-huvud' },
            { key: 'PENSION', en: 'pension', sv: 'pension' },
            { key: 'PRIVATE_INSURANCE', en: 'private-healthcare-insurance', sv: 'privatvardsforsakring' },
            { key: 'OTHER_INSURANCES', en: 'insurance', sv: 'forsakring' },
            { key: 'FREELANCE_LIFE', en: 'working-as-a-freelancer-and-invoicing-without-tax-registration', sv: 'att-jobba-som-frilansare-och-fakturera-utan-fskatt' }
        ]
    },

    {
        title: 'SELF_EMPLOYMENT',
        links: [
            { key: 'ABOUT_SELF_EMPLOYMENT', en: 'self-employment', sv: 'egenanstallning' },
            { key: 'GOOD_WORK_CONDITIONS', en: 'start-your-own-business-or-invoice-as-a-private-person', sv: 'starta-eget-foretag-eller-fakturera-som-privatperson' },
        ]
    },
        {
        title: 'BUSINESS_SOLUTIONS',
        links: [
            { key: 'PAYROLL_FOR_EXTRA_STAFF', en: 'business', sv: 'foretag' }]
    },


];